import { createBrowserRouter, Navigate } from "react-router-dom";

//* Import Components
import Login from "./views/auth/Login/Login";
import SignUp from "./views/auth/SignUp";
import NotFountPage from "./views/common/NotFountPage";
import Components from "./views/Components.jsx";
import AppWrapper from "./AppWrapper.jsx";
import { setHeaderTitle } from "./Redux Store/Slices/header.js";
import store from "./Redux Store/store.js";
import axios from "axios";
import { getUserProfileUrl } from "./utils/urls.js";
import { setUserData } from "./Redux Store/Slices/auth.js";
import { lazy } from "react";
import LeadDetails from "./views/Leads/LeadDetailsModal.jsx";
import LeadDetailsPage from "./views/Leads/LeadDetailsModal.jsx";
import LeadsTab from "./views/Leads/LeadsTab.js";
import Configurations from "./views/Configurations/Configurations.jsx";
import ProductsPage from "./views/Configurations/Product/ProductPage.jsx";
import MobileConfigurations from "./views/Configurations/MobileConfigurations/MobileConfigurations.jsx";
import FinancialPartner from "./views/Remuneration/company/FinancialPartner.jsx";
import AdvisorRenumeration from "./views/Remuneration/advisors/AdvisorRenumeration.jsx";
import AdvsiorDetail from "./views/Remuneration/advisors/AdvsiorDetail.jsx";
import InvoiceDetail from "./views/Remuneration/InvoiceDetail.jsx";
import CompanyDetail from "./views/Remuneration/company/CompanyDetail.jsx"
import AppWrapperWithoutLayout from "./AppWrapperWithoutLayout.jsx";
import ForgotPassword from "./views/auth/forgotPassword/forgotPassword.jsx";
import ChangePassword from "./views/auth/forgotPassword/changePassword.jsx";
import Notification from "./views/Configurations/Notifications/Notification.jsx";
import { useSelector } from "react-redux";
import Settings from "./views/Configurations/Settings/Settings.jsx";
import Invoice from "./views/Configurations/Invoice/Invoice.jsx";
import ProductOrdering from "./views/Configurations/ProductOrdering/ProductOrdering.jsx";
import AdvisorInfoPage from "./views/Advisors/AdvisorInfoPage.jsx";
import AdvisorDetailPage from "./views/Advisors/AdvisorDetailPage.jsx";
import ViewCourseDetails from "./views/Learning Module/ViewCourseDetails.jsx";
import PaymentDetails from "./views/Remuneration/company/PaymentDetails.jsx";
import BecomeAdvior from "./views/Become Advisor/BecomeAdvior.jsx";
import RelationshipManagers from "./views/RelationshipManagers/RelationshipManagers.jsx";
import SupportConsole from "./views/Support/SupportConsole.jsx";
import SubscriptionsAdmin from "./views/Subscriptions/SubscriptionsAdmin.jsx";
import CertificationAdmin from "./views/Certification/CertificationAdmin.jsx";
import ReferralsAdmin from "./views/Referrals/ReferralsAdmin.jsx";
import PipelineDashboard from "./views/Pipeline/PipelineDashboard.jsx";
import JourneysAdmin from "./views/Journeys/JourneysAdmin.jsx";
const { Dashboard } = await import("./views/Dashboard/Dashboard.jsx");
const { Leads } = await import("./views/Leads/Leads.jsx");
const { Advisors } = await import("./views/Advisors/Advisrors.jsx");
const { InsuranceProviders } = await import("./views/Insurance Providers/InsuranceProviders.jsx");
const { ProductCatalogue } = await import("./views/Product Catalogue/ProductCataloguue.jsx");
const { LearningModule } = await import("./views/Learning Module/LearningModule.jsx");
const { Remuneration } = await import("./views/Remuneration/Remuneration.jsx");
const { ProviderDetail } = await import("./views/Insurance Providers/ProviderDetail.jsx")
const { AllLeads } = await import("./views/Leads/AllLeads.js");
// const {Configurations} = await import("./views/Configurations/Configurations.jsx");
const { Location } = await import("./views/Location/Location.jsx")
const { AddLocation } = await import("./views/Location/AddLocation.jsx")
const { UsersManagement } = await import("./views/Users/UserManagement.jsx");
const { AddAdmin } = await import("./views/Users/AddAdmin.jsx");
const { AddRolesPage } = await import('./views/Users/AddRolesPage.jsx');
const { EditRolePage } = await import("./views/Users/EditRolePage.jsx");
const { EditAdmin } = await import("./views/Users/EditUser.jsx");

async function fetchUsersData() {
  return new Promise(async (resolve, reject) => {
    try {
      await axios
        .get(getUserProfileUrl)
        .then((res) => {
          console.log(res.data);
          store.dispatch(setUserData(res.data?.data));
          // toast.success("Login Successfull");
          resolve({ status: true });
        })
        .catch((err) => {
          // reject({ status: false });
          // toast.error("Something went wrong, refresh page and try again");
          // window.location = "/login";
        });
      resolve({ status: true });
    } catch (err) {
      reject({ status: false });
    }
  })
}
// const PrivateRoute = ({ children }) => {
//   const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

//   return isAuthenticated ? children : <Navigate to="/login" />;
// };
let routes = createBrowserRouter([
  {
    path: "/",
    element: <AppWrapper />,
    loader: async () => {
      const res = await fetchUsersData();
      console.log('res: ', res);
      if (res.status) {
        return true;
      } else return false;
    },
    children: [
      {
        path: "/",
        lazy: async () => {
          return { Component: Dashboard };
        },
        loader: async () => {
          store.dispatch(setHeaderTitle("Dashboard"));
          return null;
        },
      },
      {
        path: "/sign-up",
        lazy: async () => {
          return { Component: SignUp };
        },
      },
      {
        path: "/leads/all-leads/",
        lazy: async () => {
          return { Component: LeadsTab };
        },
        // loader: async () => {
        //   store.dispatch(setHeaderTitle("Leads"));
        //   return null;
        // },
      },
      {
        path: "/leads/details",
        lazy: async () => {
          return { Component: LeadDetailsPage };
        },
        // loader: async () => {
        //   store.dispatch(setHeaderTitle("Leads"));
        //   return null;
        // },
      },
      {
        path: "/leads/",
        lazy: async () => {
          return { Component: Leads };
        },
        loader: async () => {
          store.dispatch(setHeaderTitle("Leads"));
          return null;
        },
        children: [
          {
            path: "all-leads/",
            lazy: async () => {
              return { Component: AllLeads };
            },
            loader: async () => {
              store.dispatch(setHeaderTitle("All leads"));
              return null;
            },
          },
        ],
      },
      {
        path: "/remuneration/",
        lazy: async () => {
          return { Component: Remuneration };
        },
      },
      {
        path: "/getPaymentDetails/:id",
        lazy: async () => {
          return { Component: PaymentDetails }
        },
      },
      {
        path: "/learning-module",
        lazy: async () => {
          return { Component: LearningModule };
        },
      },

         {
        path: "/become-advisor",
        lazy: async () => {
          return { Component: BecomeAdvior };
        },
      },
         {
        path: "/relationship-manager",
        lazy: async () => {
          return { Component: RelationshipManagers };
        },
      },
      {
        path: "/support",
        element: <SupportConsole />,
        loader: async () => {
          store.dispatch(setHeaderTitle("Support"));
          return null;
        },
      },
      {
        path: "/subscriptions",
        element: <SubscriptionsAdmin />,
        loader: async () => {
          store.dispatch(setHeaderTitle("Subscriptions"));
          return null;
        },
      },
      {
        path: "/certification",
        element: <CertificationAdmin />,
        loader: async () => {
          store.dispatch(setHeaderTitle("Certification"));
          return null;
        },
      },
      {
        path: "/referrals",
        element: <ReferralsAdmin />,
        loader: async () => {
          store.dispatch(setHeaderTitle("Referrals"));
          return null;
        },
      },
      {
        path: "/pipeline",
        element: <PipelineDashboard />,
        loader: async () => {
          store.dispatch(setHeaderTitle("Pipeline"));
          return null;
        },
      },
      {
        path: "/journeys",
        element: <JourneysAdmin />,
        loader: async () => {
          store.dispatch(setHeaderTitle("Journeys"));
          return null;
        },
      },
      {
        path: "/fundamental-course-module/:id",
        lazy: async () => {
          return { Component: ViewCourseDetails };
        },
      },
      {
        path: "/product-catalogue",
        lazy: async () => {
          return { Component: ProductsPage };
        },
      },
      {
        path: "/insurance-providers/",
        lazy: async () => {
          return { Component: InsuranceProviders };
        },
        children: [
          // {path: 'provider-detail',
          // lazy: async () => {
          //   return { Component: ProviderDetail};
          // }}
        ]
      },
      {
        path: 'insurance-providers/provider-detail',
        lazy: async () => {
          return { Component: ProviderDetail };
        }
      },
      {
        path: "/advisors",
        lazy: async () => {
          return { Component: Advisors };
        },
      },
      {
        path: "/configurations",
        lazy: async () => {
          return { Component: Configurations };
        },
      },
      {
        path: "/mobileconfigurations",
        lazy: async () => {
          return { Component: MobileConfigurations };
        },
      },
      {
        path: "/notifications",
        lazy: async () => {
          return { Component: Notification };
        },
      },
      {
        path: "/settings",
        lazy: async () => {
          return { Component: Settings };
        },
      },
      {
        path: "/invoice",
        lazy: async () => {
          return { Component: Invoice };
        },
      },
      {
        path: "/product-ordering",
        lazy: async () => {
          return { Component: ProductOrdering };
        },
      }
      , {
        path: "/partner",
        lazy: async () => {
          return { Component: FinancialPartner };
        },

      },
      {
        path: "/advisor",
        lazy: async () => {
          return { Component: AdvisorRenumeration };
        },

      }, {
        path: "/advisordetail",
        lazy: async () => {
          return { Component: AdvsiorDetail };
        },

      },
      {
        path: "/advisorDetail",
        lazy: async () => {
          return { Component: AdvsiorDetail };
        },

      },
      {
        path: "/advisors/advisorview",
        lazy: async () => {
          return { Component: AdvisorDetailPage };
        },

      },
      {
        path: "/advisors/advisorDetail",
        lazy: async () => {
          return { Component: AdvisorInfoPage };
        },

      },
      {
        path: "/invoicedetail",
        lazy: async () => {
          return { Component: InvoiceDetail };
        },

      }, {
        path: "/companydetail",
        lazy: async () => {
          return { Component: CompanyDetail };
        },
      },
      {
        path: "/location",
        lazy: async () => {
          return { Component: Location };
        },
      },
      {
        path: "/add-location",
        lazy: async () => {
          return { Component: AddLocation };
        },
      },
      {
        path: "/edit-location/:id",
        lazy: async () => {
          const module = await import("./views/Location/EditLocation.jsx");
          return { Component: module.default };
        },
      },
      {
        path: "/users",
        lazy: async () => {
          return { Component: UsersManagement };
        },
      },
      {
        path: "/add-admin",
        lazy: async () => {
          return { Component: AddAdmin };
        },
      },
      {
        path: "/edit-admin/:id",
        lazy: async () => {
          return { Component: EditAdmin };
        },
      },
      {
        path: "/add-roles",
        lazy: async () => {
          return { Component: AddRolesPage }
        }
      },
      {
        path: "/edit-role/:id",
        lazy: async () => {
          return { Component: EditRolePage }
        }
      },
    ],

  },
  {
    path: "/login",
    lazy: async () => {
      return { Component: Login };
    },
  },
  {
    path: "/forgot-password",
    lazy: async () => {
      return { Component: ForgotPassword };
    },
  },
  {
    path: "/change-password",
    lazy: async () => {
      return { Component: ChangePassword };
    },
  },




  { path: "/components", element: <Components /> },

  { path: "*", element: <NotFountPage /> },
]);

export default routes;
